import { OctagonPause } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const OctagonPauseIcon = createLucideIcon(OctagonPause);
